import React from "react";
import * as yup from "yup";

import {useGlobalState} from "../../../GlobalState";
import AvatarWithUpload from "../../../components/AvatarWithUpload";
import AttributeList from "../../../components/AttributeList";
import TextAttributeForm from "../../../components/AttributeForm/TextAttributeForm";
import useDialog from "../../../hooks/useDialog";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import lepri from "../../../services/lepri-js";

import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import ChangePasswordDialog from "./ChangePasswordDialog";
import ListSubheader from "@mui/material/ListSubheader";


const AccountCard = () => {
    const {userData, updateUser} = useGlobalState();
    const {user} = userData;
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const initialLetters = `${user.name.charAt(0)}${user.surname.charAt(0)}`;

    const handleUpdateUser = async (formDialog, data) => {
        try {
            await updateUser(data);
            formDialog.close();
            showSuccessNotification("Salvataggio completato");
        } catch (e) {
            showErrorNotification(e);
        }
    }

    const handleUpdateAvatar = async (file) => {
        const image = await lepri(file, { minSideDimension: 100});
        const formData = new FormData();
        formData.append("avatar", image);
        await updateUser(formData);
    }

    const formUserName = useDialog();
    const formUserSurname = useDialog();
    const formPassword = useDialog();

    const userAttributes = [
        {
            label: "Nome",
            value: user.name,
            icon: <PersonIcon/>,
            defaultValue: "",
            formDialog: formUserName,
            formComponent: <TextAttributeForm attribute="name"
                                              label="Nome"
                                              validationSchema={yup.object().shape({
                                                  name: yup.string()
                                                      .required('Campo obbligatorio')
                                              })}
                                              value={user.name}
                                              onClose={formUserName.close}
                                              onSubmit={(data) => handleUpdateUser(formUserName, data)}
                                              isLoading={formUserName.loading}/>
        },
        {
            label: "Cognome",
            value: user.surname,
            icon: <PersonIcon/>,
            defaultValue: "",
            formDialog: formUserSurname,
            formComponent: <TextAttributeForm attribute="surname"
                                              label="Cognome"
                                              validationSchema={yup.object().shape({
                                                  surname: yup.string()
                                                      .required('Campo obbligatorio')
                                              })}
                                              value={user.surname}
                                              onClose={formUserSurname.close}
                                              onSubmit={(data) => handleUpdateUser(formUserSurname, data)}
                                              isLoading={formUserSurname.loading}/>
        }];
    const loginAttributes = [
        {
            label: "Email",
            value: user.email,
            icon: <AlternateEmailIcon/>,
            defaultValue: "",
            readOnly: true,
        },
        {
            label: "Password",
            value: "●●●●●●●●",
            icon: <LockIcon/>,
            defaultValue: "",
            formDialog: formPassword,
            formComponent: <ChangePasswordDialog onClose={formPassword.close}/>
        }
        ];

    return <Card sx={{position: "relative"}}>
        <CardContent>
            <Container maxWidth='sm' disableGutters>
                <Stack>
                    <Stack alignItems="center">
                        <AvatarWithUpload imgAlt={user.name}
                                          imgSrc={user.avatar}
                                          width="120px"
                                          height="120px"
                                          onUpdate={handleUpdateAvatar}>
                            {initialLetters}
                        </AvatarWithUpload>
                    </Stack>
                    <AttributeList attributes={userAttributes}/>
                    <ListSubheader>Credenziali e cambio password:</ListSubheader>
                    <AttributeList attributes={loginAttributes}/>
                </Stack>
            </Container>
        </CardContent>
    </Card>
}

export default AccountCard;